<template>
    <div id="appointment-list">
        <div class="row topactionform">
            <div class="col-xs-5" style="padding-right: 0">
                <div class="smalltitle">List Clinic</div>
            </div>
            <div class="col-xs-7" >
                <form class="onelineform flowsearch" @submit.prevent="filterClinic">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <input type="text" placeholder="Name or leave blank for search all"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 50%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
        </div>
        <div class="blockcont">
            <ul class="itemlisttable  ptemr-list">
                <li class="itemlisthead">
                    <div class="item-name">Registered Name</div>
                    <div class="item-npi">NPI</div>
                    <div class="item-total">Total</div>
                </li>
                <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i class="fas fa-spinner fa-spin"></i></li>
                <li v-if="!isLoading && dataClinics.length === 0" style="text-align: center; font-size: 16pt">No records found</li>
                <li v-if="!isLoading" class="item-clinic" v-for="(clinic, index) in dataClinics">
                    <div class="item-name">{{clinic.fullName}}</div>
                    <div class="item-npi">{{clinic.npi}}</div>
                    <div class="item-total">{{clinic.totalDoctor}}</div>
                </li>
            </ul>
        </div>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>
    </div>
</template>

<script>
import Pagination from '../../global/Pagination.vue'
import axios from '../../client'
import moment from 'moment'
import config from '../../config'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Common from '../mixins/Common.vue'

export default {
  name: 'Clinic',
  components: {
    Pagination
  },
  mixins: [Common],
  data () {
    return {
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isLoading: false,
      dataClinics: [],
      formSearch: {
        keySearch: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff',
      storeLocationObject: 'locationObject'
    })
  },
  watch: {},
  updated () {},
  mounted () {
    this.loadListClinic()
  },
  beforeDestroy () {},
  methods: {
    filterClinic () {
      this.loadListClinic()
    },
    async loadListClinic () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let params = {
        page: this.paginate.page,
        perPage: this.paginate.perPage,
        keySearch: this.formSearch.keySearch
      }
      let response = await axios.get(`/clinics`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          this.dataClinics = response.data.data.clinics
          this.paginate.page = response.data.data.clinics.currentPage
          this.paginate.total = response.data.data.clinics.total
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadListClinic()
    }
  }
}
</script>
<style>

</style>
<style scoped="">
    .item-name {
        width: 50% !important;
    }
</style>
